import "core-js/modules/es6.function.name";
export default function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}